<template>
	<v-row no-gutters class="fill-height">
		<v-col cols="12">
			<h1 class="big" :style="{ marginTop: `${$vuetify.breakpoint.lgAndUp ? 7 : 1}vh` }">
				Create your {{ firstFlowCreation ? 'first' : '' }} flow by choosing a trigger type
			</h1>
			<div class="flows_cont">
				<v-row justify="space-around" :style="{ marginTop: `${$vuetify.breakpoint.lgAndUp ? 5 : 1}vh` }">
					<v-col cols="auto" class="flow_type" v-for="flowType in flows" :key="flowType.id">
						<h3>{{ flowType.title }}</h3>
						<h3 class="desc">{{ flowType.desc }}</h3>
						<div
							v-for="flow in flowType.items"
							:class="['mt-3', flow.disabled ? 'disabled' : 'clickable']"
							:key="flow.id"
							@click="setSelectedFlowType(flow)"
						>
							<v-card
								:max-width="`${$vuetify.breakpoint.xl ? 310 : 300}px`"
								class="flow_card px-6 pt-5 pb-4"
								:class="{ selected: selectedFlow == flow }"
							>
								<h2>{{ flow.title }}</h2>
								<div class="mt-6" style="position: relative">
									<SIcon :name="flow.svg" />
								</div>
								<h5 class="light mt-4" style="height: 30px">
									{{ flow.desc }}
									<span style="font-weight: bold" v-if="flow.disabled"
										><br />
										(Closed beta)</span
									>
								</h5>
							</v-card>
						</div>
					</v-col>
				</v-row>
			</div>
			<transition name="fromBottom">
				<div class="bot_wrp" v-if="selectedFlow">
					<v-form ref="form" v-model="formValid" @submit.prevent="createElement">
						<div>
							<v-text-field
								placeholder="Name your flow "
								height="45"
								:rules="rules"
								class="fl_txt param_field"
								filled
								single-line
								outlined
								v-model="flowTitle"
							></v-text-field>
						</div>
						<v-btn tile color="primary" class="med_btn mt-6" height="45" type="submit" :loading="loading">Create</v-btn>
					</v-form>
				</div>
			</transition>
			<FlowDialogNewFlow :newFlowDialog.sync="newFlowDialog" />
		</v-col>
	</v-row>
</template>

<script>
import { mapActions } from 'vuex';

import FlowDialogNewFlow from '@/components/dialogs/FlowDialogNewFlow';
import { FlowType, WorkflowAccessType } from '@ply-io/ply-front-shared-utilities';

export default {
	name: 'NewFlow',
	props: {
		showDialog: { type: Boolean, required: false, default: false },
	},
	components: {
		FlowDialogNewFlow,
	},
	created() {},
	methods: {
		...mapActions(['selectedWorkflow/createAndSelectWorkflow']),
		async createElement() {
			this.$refs.form.validate();
			if (!this.formValid) return;

			// Here we create a webhook flow.
			if (this.selectedFlow) {
				this.loading = true;
				await this['selectedWorkflow/createAndSelectWorkflow']({
					workflow: { workflow_title: this.flowTitle, flow_type: this.flowTypeCode, access_type: this.flowAccessType },
				});
				this.loading = false;
				this.$emit('update:showDialog', false);
			} else {
				// this.newFlowDialog = true;
			}
		},
		initState() {
			this.selectedFlow = null;
			this.flowTitle = '';
			this.$refs.form.resetValidation();
		},
		setSelectedFlowType(flow) {
			if (flow.disabled) {
				return;
			}
			this.selectedFlow = this.selectedFlow && this.selectedFlow.id == flow.id ? null : flow;
		},
	},
	computed: {
		firstFlowCreation() {
			return this.$route.name === 'NewFlow';
		},
		flowTypeCode() {
			if (!this.selectedFlow) return FlowType.Cloud;
			return this.selectedFlow.flowType;
		},
		flowAccessType() {
			if (!this.selectedFlow) return WorkflowAccessType.SharedUsersOnly;
			return this.selectedFlow.flowAccessType;
		},
		flows() {
			return [
				{
					id: 1,
					title: 'Experience Flow',
					desc: 'A flow you and your team can interact with',
					items: [
						{
							id: 1,
							title: 'UI Element',
							desc: 'Add Buttons and text fields to any website, that can trigger a flow or present relevant data.',
							svg: 'svg-experience',
							flowType: FlowType.Experience,
							flowAccessType: WorkflowAccessType.SharedUsersOnly,
							disabled: true,
						},
						{
							id: 2,
							title: 'Shortcut',
							desc: 'Create a flow that starts with a slash command, keyboard shortcut or mouse right-click',
							svg: 'svg-shortcut2',
							flowType: FlowType.Experience,
							flowAccessType: WorkflowAccessType.SharedUsersOnly,
							disabled: true,
						},
					],
				},
				{
					id: 2,
					title: 'Public Experience Flow',
					desc: 'A flow anyone on the web can interact with.',
					items: [
						{
							id: 3,
							title: 'Link',
							desc: 'Create a flow that starts when someone clicks on a link',
							svg: 'svg-link',
							flowType: FlowType.Tool,
							flowAccessType: WorkflowAccessType.Anyone,
							disabled: false,
						},
						{
							id: 4,
							title: 'Embedded widget',
							desc: 'Create a flow that’s embedded in your website',
							svg: 'svg-embeded-widget',
							flowType: FlowType.Tool,
							flowAccessType: WorkflowAccessType.Anyone,
							disabled: true,
						},
					],
				},
				{
					id: 3,
					title: 'Cloud Flow',
					desc: 'A flow that happens magically in the background',
					items: [
						{
							id: 5,
							title: 'App Event',
							desc: 'Create a flow starts that starts when something happens in one of your apps',
							svg: 'svg-app-event',
							flowType: FlowType.Cloud,
							flowAccessType: WorkflowAccessType.SharedUsersOnly,
							disabled: true,
						},
						{
							id: 6,
							title: 'Webhook',
							desc: 'Create a flow that starts with a webhook',
							svg: 'svg-webhook',
							flowType: FlowType.Cloud,
							flowAccessType: WorkflowAccessType.SharedUsersOnly,
						},
					],
				},
			];
		},
	},
	watch: {
		showDialog: {
			handler(newV) {
				if (newV) {
					this.initState();
				}
			},
		},
	},
	data: () => ({
		newFlowDialog: null,
		selectedFlow: null,
		flowTitle: '',
		formValid: false,
		loading: false,
		rules: [(v) => !!v || 'Name is required'],
	}),
};
</script>

<style scoped>
.clickable {
	cursor: pointer;
}
.disabled {
	opacity: 0.6;
}
.flow_card {
	border: 1px solid #dce0e9;
	border-radius: 15px !important;
	box-shadow: none !important;
	transition: all 0.3s ease-in-out;
	box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
}
.flow_card:hover {
	box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.03) !important;
}
.flow_card.selected {
	border: 1px solid #bddeff !important;
	box-shadow: 0px 4px 14px rgba(110, 183, 255, 0.47) !important;
}

.flow_card h2 {
	font-size: 16px;
	font-weight: 500;
	color: #f9487f !important;
}

.flow_type h3 {
	color: #292829 !important;
	font-size: 14px !important;
	font-weight: 700 !important;
}
.flow_type h3.desc {
	color: #919191 !important;
	font-size: 14px !important;
	font-weight: 300 !important;
}
h5.light {
	color: #919191;
	font-weight: 400;
	font-size: 12px;
	line-height: 15px;
}
.flows_cont {
	width: 100%;
	max-width: 1200px;
	display: inline-block;
	position: relative;
}
.bot_wrp {
	position: absolute;
	left: 0px;
	right: 0px;
	bottom: 20px;
	height: 150px;
}
.fl_txt {
	width: 590px !important;
	position: relative;
	display: inline-block;
}
</style>
